module.exports = __webpack_public_path__ + "img/gala-logo.d9b0ac04.svg";